import Vue from "vue";
import Button from './ui/Button'
Vue.component('Button', Button);